"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CallAPI = require("01_core/components/system/CallAPI");
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _authorityUtil = _interopRequireDefault(require("01_core/logics/authorityUtil"));
var _openSSO = require("01_core/logics/openSSO");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _KansaUnavailability = _interopRequireDefault(require("../common/components/layout/KansaUnavailability"));
var _Consts = require("../common/consts/Consts");
var _KansaReportSearchMain = _interopRequireDefault(require("./KansaReportSearchMain"));
var _KansaReportRefer = _interopRequireDefault(require("./creation/KansaReportRefer"));
var _KansaReportRegister = _interopRequireDefault(require("./creation/KansaReportRegister"));
var _KansaReportDetail = _interopRequireDefault(require("./detail/KansaReportDetail"));
var _KansaReportEvaluationRefer = _interopRequireDefault(require("./evaluation/KansaReportEvaluationRefer"));
var _KansaReportEvaluationRegister = _interopRequireDefault(require("./evaluation/KansaReportEvaluationRegister"));
var _kansaReportActions = require("./kansaReportActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 監査報告書コンテナ
 */
class KansaReportContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "openReport", () => {
      const {
        targetReport
      } = this.props;
      const condition = {
        kaishaSummary: targetReport.kaishaSummary,
        kansaTgtNendo: targetReport.kansaTgtNendo,
        hikansabumonKaishaCd: targetReport.hikansabumonKaishaCd,
        hikansabumonSoshikiCd: targetReport.hikansabumonSoshikiCd
      };
      const params = {
        keyReferCondition: JSON.stringify(condition),
        keySubContent: _kansaReportActions.CONTENTS.REFER
      };
      (0, _openSSO.openSubWindowWithParams)('kansa_report', _Consts.CONSTS.COMMON_SUB_WINDOW_KEY + '_refer', '', '', params).focus();
    });
    _defineProperty(this, "openDetail", (entries, targetJigyo, hakkenjikoBunruiCd) => {
      const condition = {
        kaishaSummary: entries.kaishaSummary,
        kansaTgtNendo: entries.kansaTgtNendo,
        hikansabumonKaishaCd: entries.hikansabumonKaishaCd,
        hikansabumonSoshikiCd: entries.hikansabumonSoshikiCd,
        kansaTgtJigyoId: targetJigyo.kansaTgtJigyoId,
        hakkenjikoBunruiCd: hakkenjikoBunruiCd
      };
      const params = {
        keyDetailCondition: JSON.stringify(condition),
        keySubContent: _kansaReportActions.CONTENTS.DETAIL
      };
      (0, _openSSO.openSubWindowWithParams)('kansa_report', _Consts.CONSTS.COMMON_SUB_WINDOW_KEY + '_detail', '', '', params).focus();
    });
    const {
      systemSettings,
      loginUserInfo,
      setInParentCompany,
      showSubwindow,
      isNewWindow,
      keySubContent,
      keyReferCondition,
      keyDetailCondition
    } = props;
    if (_authorityUtil.default.hasPermission(props.pms, _kansaReportActions.PERMISSION_KEY.KAISHA_SOSHIKI_SELECT_ALL) || loginUserInfo.kaishaCd === systemSettings.core_parent_company_cd) {
      // ログインユーザがシステム管理者(=会社組織選択が会社全ての場合)、または、所属会社がNECの場合
      setInParentCompany(true);
    } else {
      // 上記以外の場合
      setInParentCompany(false);
    }
    if (isNewWindow) {
      if (keySubContent) {
        showSubwindow(keySubContent, keyReferCondition, keyDetailCondition);
      }
    }

    // 機能利用可否判定
    this.state = {
      avail: true
    };
  }
  componentDidMount() {
    this.props.callAPI(_APIs.KANSA_AVAILABILITY).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        this.setState({
          avail: response.data.availability
        });
      }
    }).catch(e => {
      if ((e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED || (e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.CALLING) {
        return;
      }
      throw e;
    });
  }
  componentWillUnmount() {
    this.props.clear();
  }
  render() {
    const {
      containerInfo,
      pms
    } = this.props;

    // 機能利用不可の場合は機能利用不可画面を表示する
    if (!this.state.avail) {
      return /*#__PURE__*/_react.default.createElement(_KansaUnavailability.default, {
        titleLabelId: _labelConsts.LABEL.KANSA_REPORT_SEARCH
      });
    }
    switch (containerInfo.subContent) {
      case _kansaReportActions.CONTENTS.REFER:
        return /*#__PURE__*/_react.default.createElement(_KansaReportRefer.default, {
          openDetail: this.openDetail
        });
      case _kansaReportActions.CONTENTS.DETAIL:
        return /*#__PURE__*/_react.default.createElement(_KansaReportDetail.default, null);
      default:
        break;
    }
    switch (containerInfo.dispContent) {
      case _kansaReportActions.CONTENTS.SEARCH:
        return /*#__PURE__*/_react.default.createElement(_KansaReportSearchMain.default, {
          pms: pms
        });
      case _kansaReportActions.CONTENTS.REGISTER:
        return /*#__PURE__*/_react.default.createElement(_KansaReportRegister.default, {
          openDetail: this.openDetail
        });
      case _kansaReportActions.CONTENTS.UPDATE:
        return /*#__PURE__*/_react.default.createElement(_KansaReportRegister.default, {
          openDetail: this.openDetail
        });
      case _kansaReportActions.CONTENTS.REFER:
        return /*#__PURE__*/_react.default.createElement(_KansaReportRefer.default, {
          openDetail: this.openDetail
        });
      case _kansaReportActions.CONTENTS.EV_REGISTER:
        return /*#__PURE__*/_react.default.createElement(_KansaReportEvaluationRegister.default, {
          openReport: this.openReport
        });
      case _kansaReportActions.CONTENTS.EV_UPDATE:
        return /*#__PURE__*/_react.default.createElement(_KansaReportEvaluationRegister.default, {
          openReport: this.openReport
        });
      case _kansaReportActions.CONTENTS.EV_REFER:
        return /*#__PURE__*/_react.default.createElement(_KansaReportEvaluationRefer.default, {
          openReport: this.openReport
        });
      case _kansaReportActions.CONTENTS.DETAIL:
        return /*#__PURE__*/_react.default.createElement(_KansaReportDetail.default, null);
      default:
        return null;
    }
  }
}
const mapStateToProps = state => {
  return {
    systemSettings: state.coreLoginInfo.systemSettings,
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    containerInfo: state.kansaReport.containerInfo,
    userInfo: state.kansaReport.userInfo,
    targetReport: state.kansaReport.targetReport,
    reportEntries: state.kansaReport.creation.entries
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setInParentCompany: value => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_IN_PARENT_COMPANY](value)),
    showSubwindow: (content, keyReferCondition, keyDetailCondition) => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SHOW_SUBWINDOW](content, keyReferCondition, keyDetailCondition)),
    clear: () => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CLEAR]())
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _CustomRouter.withRouter)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KansaReportContainer))));